define("hypo_elements/Partials/Image/Image", ["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ImageContentElement = void 0;
    var ImageContentElement = /** @class */ (function () {
        function ImageContentElement(devicePixelRatio) {
            this.devicePixelRatio = devicePixelRatio;
        }
        ImageContentElement.prototype.resolveImage = function ($image) {
            var _this = this;
            var imageData = new ImageData($image.data("src"), $image.attr("width"));
            var srcSet = $image.data("srcset");
            var srcSetCandidates = [];
            if (srcSet) {
                var itemWidth_1 = 0;
                srcSetCandidates = srcSet.split(",");
                if ($image.data("preload") == "resolution") {
                    itemWidth_1 = window.innerWidth;
                }
                else {
                    itemWidth_1 = $image.width();
                }
                srcSetCandidates.forEach(function (srcSetCandidate, index) {
                    var srcSetCandidateImageData = ImageContentElement.getSrcSetCandidateImageData(srcSetCandidate.trim());
                    imageData = ImageContentElement.updateImageData(srcSetCandidateImageData, imageData, itemWidth_1 * _this.devicePixelRatio);
                    var isLastElement = index == srcSetCandidates.length - 1;
                    if (isLastElement) {
                        imageData = ImageContentElement.updateMaxImageData(srcSetCandidateImageData, imageData, itemWidth_1 * _this.devicePixelRatio);
                    }
                });
            }
            return imageData.getSource();
        };
        ImageContentElement.updateImageData = function (srcSetCandidate, currentImageData, neededImagePixelwidth) {
            if (srcSetCandidate === undefined) {
                return currentImageData;
            }
            if (neededImagePixelwidth <= srcSetCandidate.getWidth() && currentImageData.getWidth() > srcSetCandidate.getWidth()) {
                return srcSetCandidate;
            }
            return currentImageData;
        };
        ImageContentElement.updateMaxImageData = function (srcSetCandidate, currentImageData, neededImagePixelwidth) {
            if (srcSetCandidate === undefined) {
                return currentImageData;
            }
            if (neededImagePixelwidth > srcSetCandidate.getWidth()) {
                return srcSetCandidate;
            }
            return currentImageData;
        };
        ImageContentElement.getSrcSetCandidateImageData = function (srcSetCandidateString) {
            var srcSetCandidateParts = srcSetCandidateString.split(" ");
            if (srcSetCandidateParts[0] && srcSetCandidateParts[1]) {
                return new ImageData(srcSetCandidateParts[0].trim(), parseInt(srcSetCandidateParts[1]));
            }
        };
        return ImageContentElement;
    }());
    exports.ImageContentElement = ImageContentElement;
    var ImageData = /** @class */ (function () {
        function ImageData(source, width) {
            this.source = source;
            this.width = width;
        }
        ImageData.prototype.getSource = function () {
            return this.source;
        };
        ImageData.prototype.getWidth = function () {
            return this.width;
        };
        return ImageData;
    }());
    $(function () {
        var $images = $(".image_placeholder");
        var imageCount = $images.length;
        var imageContentElement = new ImageContentElement(window.devicePixelRatio);
        function updateImage($image) {
            var newImageSrc = imageContentElement.resolveImage($image);
            var newImage = new Image();
            newImage.onload = function () {
                $image.attr("src", newImageSrc);
                $image.addClass("image_placeholder--is-faded-in");
            };
            newImage.src = newImageSrc;
        }
        function onIntersect(entries, observer) {
            if (imageCount === 0) {
                observer.disconnect();
            }
            entries.forEach(function (entry) {
                if (entry.intersectionRatio > 0) {
                    imageCount--;
                    observer.unobserve(entry.target);
                    updateImage($(entry.target));
                }
            });
        }
        var observer = new IntersectionObserver(onIntersect, {
            rootMargin: "50px 0px",
            threshold: 0.01,
        });
        $images.each(function (index, image) {
            observer.observe(image);
        });
    });
});
